import store from '@/store';

import { FePreferenceService } from '@/core/fe-preferences';
import { OneTimePassService } from '@/core/one-time-pass';
import { VendorUserService } from '@/core/vendor-user';
import { UserService } from '@/core/user';
import { WorkerService } from '@/core/worker';
import { WorkerAssessmentService } from '@/core/worker-assessment';
import { WorkerOneTimePassService } from '@/core/worker-one-time-pass';

import { AccessRequestConstants } from '@/core/access-request';

export default {
  fetchUser,
  fetchVendorUser,
  fetchWorkerUuid,
  createWorkerForUser,
  fetchWorker,
  fetchOneTimePassUsingQueryParams,
  createWorkerOneTimePass,
  fetchWorkerOneTimePassUsingQueryParams,
  fetchWorkerOneTimePassStatus,
  fetchWorkerAssessment,
  hasWorkerOnBoarded,
};

async function fetchUser() {
  return _.get(store.state, 'user') || UserService.getUser();
}

async function fetchVendorUser() {
  const user = await fetchUser();
  return _.get(store.state, 'vendorUser') || VendorUserService.get(user.uuid);
}

async function fetchWorkerUuid() {
  const vendorUser = await fetchVendorUser();
  return _.get(vendorUser, 'worker.uuid');
}

async function createWorkerForUser() {
  const vendorUser = await fetchVendorUser();
  return WorkerService.createForUser(vendorUser.uuid, {});
}

async function fetchWorker() {
  const workerUuid = await fetchWorkerUuid();
  return workerUuid && (_.get(store.state, 'worker') || WorkerService.get(workerUuid));
}

async function fetchOneTimePassUsingQueryParams(route) {
  const {
    client_uuid: clientUuid,
    location_uuid: locationUuid,
  } = route.query;
  if (!clientUuid || !locationUuid) return undefined;
  const storedOTP = _.get(store.state.oneTimePass, 'oneTimePass');
  if (storedOTP) return storedOTP;

  const oneTimePass = await OneTimePassService.get(clientUuid, locationUuid);
  store.commit('oneTimePass/setOneTimePass', oneTimePass);
  return oneTimePass;
}

async function createWorkerOneTimePass(route) {
  const workerUuid = await fetchWorkerUuid();
  const oneTimePass = await fetchOneTimePassUsingQueryParams(route);
  const createdWorkerOTP = await WorkerOneTimePassService.create(workerUuid, oneTimePass.uuid);
  store.commit('oneTimePass/setWorkerOneTimePass', createdWorkerOTP);
  return createdWorkerOTP;
}

async function fetchWorkerOneTimePassUsingQueryParams(route) {
  const workerUuid = await fetchWorkerUuid();
  const oneTimePass = await fetchOneTimePassUsingQueryParams(route);
  const storedWOTP = _.get(store.state.oneTimePass, 'workerOneTimePass');
  const workerOneTimePasses = storedWOTP ? [storedWOTP] : await WorkerOneTimePassService.getForWorker(workerUuid, (oneTimePass || {}).uuid);
  const workerOTPForLocation = workerOneTimePasses.length === 1 ? workerOneTimePasses[0] : undefined;
  store.commit('oneTimePass/setWorkerOneTimePass', workerOTPForLocation);
  return workerOTPForLocation;
}

async function fetchWorkerOneTimePassStatus(route) {
  await fetchWorkerOneTimePassUsingQueryParams(route);
  return store.getters['oneTimePass/workerOneTimePassStatus'];
}

async function fetchWorkerAssessment() {
  const workerUuid = await fetchWorkerUuid();
  const workerAssessment = workerUuid && (_.get(store.state, 'oneTimePass.workerAssessment') || await WorkerAssessmentService.get(workerUuid));
  store.commit('oneTimePass/setWorkerAssessment', workerAssessment);
  return workerAssessment;
}

async function hasWorkerOnBoarded() {
  const preferenceKey = WorkerService.getWorkerOnBoardingFePreferenceKey();
  const savedPreference = await FePreferenceService.get(preferenceKey);
  const workerOnBoardingCompleted = _.get(savedPreference, 'complete_registration') || _.get(savedPreference, 'invitation_assistances');
  const vendorUser = await fetchVendorUser();
  const worker = await fetchWorker();
  const workerHasVendor = _.get(worker, 'vendor') || _.get(vendorUser, 'vendor');
  const vendorUserHasAccessRequest = _.get(vendorUser, 'access_requests', [])
    .some(accessRequest => accessRequest.status === _.get(AccessRequestConstants, 'status.pending.key'));
  if (workerOnBoardingCompleted && workerHasVendor) {
    await FePreferenceService.remove(preferenceKey);
  }
  return !!worker && !!(workerHasVendor || vendorUserHasAccessRequest || workerOnBoardingCompleted);
}
